/* CRO plan — Edit E: keeps Pix pill + parcelas in sync with the displayed
   variant price. Reads the theme's [data-price] element (updated by Stiletto
   on variant change) so it works without hooking theme-internal events. */
(function () {
  if (window.__pixPriceInit) return;
  window.__pixPriceInit = true;

  function parseCents(text) {
    var m = (text || '').replace(/[^\d.,]/g, '');
    if (!m) return null;
    var hasCents = /[.,]\d{2}$/.test(m);
    var digits = m.replace(/[^\d]/g, '');
    if (!digits) return null;
    var cents = parseInt(digits, 10);
    if (!hasCents) cents = cents * 100;
    return cents;
  }

  function fmt(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function bind(block) {
    if (block.dataset.pixBound) return;
    block.dataset.pixBound = '1';

    var priceEl = null;
    var p = block.parentElement;
    while (p && !priceEl) {
      priceEl = p.querySelector('[data-price]');
      p = p.parentElement;
    }
    if (!priceEl) return;

    var rate = parseInt(block.dataset.pixRate, 10) || 5;
    var n = parseInt(block.dataset.parcelas, 10) || 6;

    function update() {
      var cents = parseCents(priceEl.textContent);
      if (cents === null || cents <= 0) return;
      var pixEl = block.querySelector('[data-pix-price]');
      if (pixEl) pixEl.textContent = fmt(Math.round((cents * (100 - rate)) / 100));
      var parEl = block.querySelector('[data-parcela-price]');
      if (parEl) parEl.textContent = fmt(Math.floor(cents / n));
    }

    new MutationObserver(update).observe(priceEl, { childList: true, subtree: true, characterData: true });
    update();
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('[data-pix-block]') : []).forEach(bind);
  }

  scan(document);

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-pix-block]')) bind(node);
        scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
